<template>
  <div class="container-cap">
    <h1 class="text-primary">
      <small >
        <span v-if="!isNational">
          {{ region }}
        </span>
        <span v-else>
          Programme National
        </span>
        {{ year }}
      </small>
      <br>
      Résultats de la surveillance
    </h1>
    <hr>
    <div class="row">
      <div class="col-xs-12">
        <div class="panel panel-info">
          <div class="panel-heading">
            <div class="form-inline">
              <div v-if="datasetList.length === 0">
                <strong>
                  <loading-text>Récupération des jeux de données</loading-text>
                </strong>
              </div>
              <div v-else class="form-group">
                <dropdown ref="dropdown">
                  <btn type="default" class="dropdown-toggle">
                    <span v-if="dataset == null">
                      Jeu de donnée
                    </span>
                    <span v-else>
                      {{ dataset }}
                    </span>

                    <span class="caret"></span>
                  </btn>
                  <template slot="dropdown">
                    <li v-for="d in datasetList"
                        :key="`dataset-${d}`">
                      <a role="button" @click="dataset = d">
                        {{ d }}
                      </a>
                    </li>
                  </template>
                </dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="dataset">
      <div v-if="!display">
        <strong><loading-text>Chargement</loading-text></strong>
      </div>
      <div v-else class="row">
        <sui-filter-bar :multiFilterData="filterInputList"
             :multiFilterEvents="filterEvents"
             :selectionInfo="filterSelectionInfo">
        </sui-filter-bar>
        <div class="col-xs-12">
          <hr>
        </div>
        <div v-if="computingCaracteristics || computingIncidences"
             class="col-xs-12">
          <alert type="warning">
            <strong>
              <loading-text>
                Calcul des
                {{ computingCaracteristics ? 'caractéristiques' : 'incidences' }}
              </loading-text>
            </strong>
          </alert>
        </div>
        <div v-else class="col-xs-12">
          <div>
            <div class="panel panel-info">
              <div class="panel-heading">
                <div v-show="display">
                  <div class="form-inline">
                    <div v-if="computedIncidences != null" class="form-group">
                      <dropdown ref="dropdown" >
                        <btn type="warning" class="dropdown-toggle">
                          Résultats
                          <span v-if="isNational">nationaux</span>
                          <span v-else>régionaux</span>
                          par type d'établissement
                          <span class="caret"></span>
                        </btn>
                        <template slot="dropdown">
                          <li v-for="(f, k) in etypes"
                              :key="`etype-${k}`">
                            <a role="button" @click="etype = f">
                              {{ f.title }}
                            </a>
                          </li>
                        </template>
                      </dropdown>
                    </div>
                    <div v-else class="form-group">
                      <btn type="warning" @click="computeIncidences">
                        <strong>Calculer et comparer toutes les incidences</strong>
                      </btn>
                    </div>
                    <div class="form-group">
                      <div class="input-group">
                        <input required ref="input"
                               id="input" tabindex="0"
                               class="form-control" v-model="text"
                               type="text"
                               placeholder="Chercher un établissement..."
                               autocomplete="off"/>
                        <div class="input-group-addon">
                          <a role="button" @click="selection = null">
                            Effacer
                          </a>
                        </div>
                      </div>
                      <typeahead v-model="selection"
                                 open-on-focus
                                 force-select
                                 target="#input"
                                 :data="establishmentList"
                                 item-key="value"/>
                    </div>
                    <div class="form-group">
                      <dropdown ref="dropdown">
                        <btn type="default" :disabled="computedIncidences == null"
                             class="dropdown-toggle">
                          Exports CSV <span class="caret"></span>
                        </btn>
                        <template slot="dropdown">
                          <li>
                            <a role="button" @click="exportComputed">
                              Incidences <span v-if="isNational">nationales</span>
                              <span v-else>régionales</span>
                            </a>
                          </li>
                          <li>
                            <a role="button" @click="exportByEstablishment">
                              Incidences par établissement
                            </a>
                          </li>
                        </template>
                      </dropdown>
                    </div>
                    <div class="form-group">
                      <btn type="default"
                           @click="invalidCollapse = !invalidCollapse">
                        Établissements exclus
                      </btn>
                    </div>
                    <div class="form-group" v-if="isNational">
                      <c-checkbox v-model="removeDoubles"
                                  type="bactADI" size="sm">
                        Retirer les doublons
                      </c-checkbox>
                    </div>
                    <div class="form-group" v-else>
                      <c-checkbox v-model="useNational"
                                  type="bactADI" size="sm">
                        Utiliser les populations nationales
                      </c-checkbox>
                    </div>
                    <sui-save-blob :target="csv"></sui-save-blob>
                  </div>
                </div>
              </div>
              <collapse v-model="invalidCollapse">
                <div class="panel-body">
                  <p>
                    Les établissements sont exclus lorsqu'ils ont déclaré deux fois
                    les données d'activité d'une même uf (comme si elle avait été
                    surveillée dans deux modalités différentes) ou si leur fiche
                    établissement n'a pas été remplie.
                  </p>
                  <table class="table table-responsive">
                    <thead>
                      <tr>
                        <th>Établissement</th>
                        <th>Finess</th>
                        <th>Erreurs</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(p, k) in invalid"
                          :key="`invalid-denominators-${k}`">
                        <td>{{p.name}}</td>
                        <td>{{p.finess}}</td>
                        <td>
                          <p v-for="(e, i) in p.errors"
                             :key="`invalid-den-${k}-${i}`">{{e}}
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </collapse>
            </div>
          </div>

          <div v-if="current != null">
            <hr>
            <h3 class="text-primary">
              {{ current.title }}
            </h3>
            <div v-if="flatResults != null">
              <sui-results-dashboard :results="flatResults"
                                 :otherTypeResults="otherFlatResults"
                                 :year="parseInt(year)"
                                 :chartYear="parseInt(year)"
                                 :referenceDataset="dataset"
                                 show-values-toggle
                                 :tabSubtitle="tabSubtitle"
                                 :chartTitle="current.title"
                                 :caracteristics="flatDistribution"
                                 :regionalIndicators="indicators"
                                 :flattenedRegionalIndicator="flattenedRegionalIndicator"
                                 :showHiddenScopes="true"
                                 :getStatisticsOverride="isNational || !useNational ? currentGetStatistics : null"
                                 :pdfOptions="pdfOptions"
                                 :listFilter="currentFilter"
                                 :disableChartOnFilter="false">
              </sui-results-dashboard>
            </div>
            <div v-else-if="currentFilter.length > 0">
              <alert type="warning">
                <p>
                  Aucune infection ne correspond au filtre choisi.
                </p>
              </alert>
            </div>
            <div v-else>
              <alert type="warning">
                <strong>
                  Aucune infection n'a été déclarée acquise dans cet
                  établissement.
                </strong>
              </alert>
            </div>
          </div>
          <div v-else>
            <hr>
            <h3 class="text-primary">
              Caractéristiques des infections
              <small><br>{{ isNational ? 'Programme National' : region }}</small>
            </h3>
            <sui-results-caracteristics
              :caracteristics="computedFlatDistribution"
              :title="`${dataset} - Caractéristiques des infections`"
              :subtitle="subtitle">
              <p>Aucune infection n'a été déclarée.</p>
            </sui-results-caracteristics>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import go from '@/gojs/go'
import loading from '@/sui/components/loadingtext'
import { mapGetters, mapState } from 'vuex'
import saveBlob from '@/sui/components/saveblob'
import spread from '@/sui/tools/spread'
import regions from '@/sui/tools/regions'
import computeIncidences from '@/sui/tools/incidence'
import results from '@/sui/data/results'
import distribution from '@/sui/data/distribution'
import caracteristics from '@/sui/data/caracteristics'
import suiResultsDashboard from '@/sui/components/results/dashboard'
import suiResultsCaracteristics from '@/sui/components/results/caracteristics'
import suiFilterBar from '@/sui/components/filter/filterbar'
import sc from '@/sui/sc/caracteristics'
import helps from '@/sui/sc/helps/surveillance'
import moment from 'moment'
import stringify from 'csv-stringify'
import search from '@/sui/tools/search'
import assert from '@/sui/tools/assert'
import filter from '@/sui/tools/filter'
import ice from '@/sui/tools/ice'
import checkbox from '@/sui/components/checkbox'
import flatten from '@/sui/data/flatten/infections'
import doubles from '@/sui/tools/sheets/doubles'

export default {
  name: 'sheets-data',

  data: function () {
    return {
      help: false,
      filterHelps: helps,

      dataset: null,
      selection: null,
      csv: null,
      etype: null,
      text: '',
      dsallReady: false,
      currentFilter: '',

      totalSheetCount: 0,
      computedInfections: null,
      referenceInfections: null,

      sc: sc,

      invalidCollapse: false,
      removeDoubles: true,
      useNational: false
    }
  },

  mounted: function () {
    if (this.datasetList.length === 0) {
      this.$store.dispatch('dataset/allSpiadiNames', !this.isNational)
    }
  },

  methods: {
    fill: function () {
      this.help = false
      this.selection = null
      this.csv = null
      this.etype = null
      this.text = ''
      this.dsallReady = false
      this.computedInfections = null
      this.referenceInfections = null
      this.invalidCollapse = false
      this.removeDoubles = true
      const vm = this
      const year = parseInt(vm.year)
      const dset = this.dataset

      const list = [
        {
          e: 'dataset/complete',
          t: 'dénominateurs',
          r: {
            name: dset,
            step: 2,
            year: year
          }
        }
      ]

      if (this.infections != null) {
        this.computedInfections = this.infections
      } else {
        list.push(
          {
            e: 'infections/all',
            t: 'bactériémies',
            r: { y: year, inf: 'bact', dset: dset }
          },
          {
            e: 'infections/all',
            t: 'pneumopathies',
            r: { y: year, inf: 'pneu', dset: dset }
          }
        )
      }

      const error = (t, e) => {
        vm.$notify(
          {
            type: 'danger',
            title: 'Erreur !',
            duration: 0,
            content: `Une erreur est survenue pendant la récupération des
${t} : ${e}.`
          }
        )
      }
      list.forEach(
        l => {
          vm.$store.dispatch(l.e, l.r).then(
            (r) => {
              const err = r.data.err
              if (err != null) {
                error(l.t, err)
              }
            }
          ).catch(
            e => { error(l.t, e) }
          )
        }
      )

      if (!this.display) {
        this.$store.dispatch('surveillances/all', this.year)
      }
    },

    exportSheets: function (e) {
      const { filter, lists } = e
      if (lists.length !== 1) {
        return
      }

      const list = lists[0]
      if (list.length === 0) {
        return
      }

      const csvList = []
      const version = parseInt(this.year) - 2018
      for (let i = 0; i !== list.length; ++i) {
        const sheet = list[i]
        const t = sheet.itb != null ? 'pneu' : 'bact'
        csvList.push(
          flatten.createExportedInfections(
            list[i],
            t,
            version
          )
        )
      }

      const infectionsColumns = flatten.getInfectionsColumns(csvList)
      const vm = this
      const date = moment().format('DD-MM-YYYY-HH-mm-ss')
      const filename = `${this.dataset} - infections - ${date} - ${filter}.csv`
      stringify(
        csvList,
        {
          header: true,
          bom: true,
          delimiter: ';',
          columns: infectionsColumns
        },
        (err, output) => {
          if (err != null) {
            vm.$notify({
              type: 'danger',
              title: 'Erreur !',
              content: `Impossible d'exporter les fiches : ${err}.`
            })
          } else {
            setTimeout(
              () => {
                vm.csv = {
                  filename: filename,
                  blob: new Blob([output], { type: 'text/plain' })
                }
              },
              10
            )
          }
        }
      )
    },

    exportComputed: function () {
      const vm = this
      const result = []
      if (vm.computedIncidences == null) {
        return
      }

      const { popstat } = vm.computedIncidences
      for (let k in popstat) {
        const p = popstat[k]
        const key = results.splitStatisticsKey(k)
        for (let t in p) {
          const s = p[t].s
          result.push(
            {
              type: t,
              tinf: key.inf,
              den: key.den,
              disc: key.disc,
              spe: key.spe,
              ent: key.ent,
              n: s.n,
              min: s.min,
              max: s.max,
              median: s.median,
              mean: s.mean,
              p25: s.p25,
              p75: s.p75,
              sd: s.sd,
              inf: s.inf,
              sup: s.sup,
              outInf: s.nOutInf,
              outSup: s.nOutSup,
              outTotal: s.nOutTotal,
              outPerc: s.nOutTotal / s.n
            }
          )
        }
      }
      stringify(
        result,
        {
          header: true,
          delimiter: ';',
          bom: true,
          columns: [
            { key: 'type', header: `Type d'établissement` },
            { key: 'disc', header: 'Discipline' },
            { key: 'spe', header: 'Spécialité' },
            { key: 'tinf', header: `Type d'infection` },
            { key: 'den', header: 'Dénominateur' },
            { key: 'ent', header: `Porte d'entrée` },
            { key: 'n', header: `Effectif` },
            { key: 'min', header: `Min` },
            { key: 'max', header: `Max` },
            { key: 'median', header: `Médiane` },
            { key: 'mean', header: `Moyenne` },
            { key: 'p25', header: `Q1` },
            { key: 'p75', header: `Q3` },
            { key: 'sd', header: `Écart type` },
            { key: 'inf', header: `Borne inférieure outlier` },
            { key: 'outInf', header: `Nombre d'outliers inférieurs` },
            { key: 'sup', header: `Borne supérieure outlier` },
            { key: 'outSup', header: `Nombre d'outliers supérieurs` },
            { key: 'outTotal', header: `Nombre d'outliers total` },
            { key: 'outPerc', header: `Pourcentage outliers` }
          ]
        },

        function (err, output) {
          if (err != null) {
            vm.$notify({
              type: 'danger',
              title: 'Erreur !',
              content: `Impossible d'exporter les données: ${err}.`
            })
          } else {
            setTimeout(
              function () {
                const region = vm.isNational ? 'NATIONALES' : 'RÉGIONALES'
                vm.csv = {
                  filename: `${vm.dataset} - EXPORT INCIDENCES ${region}.csv`,
                  blob: new Blob([output], { type: 'text/plain' })
                }
              }, 10)
          }
        })
    },

    exportByEstablishment: function () {
      const vm = this
      const result = []
      for (let e in vm.incidences) {
        const surv = vm.incidences[e]
        if (vm.invalid.find(i => i.id === e) != null) {
          continue
        }
        const name = surv.estb.name
        const finess = surv.estb.finess
        const type = results.getEstablishementType(surv.estb.type)
        const region = regions.getRegion(finess).name
        surv.incidences.forEach(
          i => {
            const et = go.denom.isSubPopDenominator(i.den) ? 'TOUS' : type
            result.push(
              {
                region: region,
                name: name,
                finess: finess,
                mod: i.mod,
                type: et,
                disc: i.disc,
                spe: i.spe,
                uf: i.uf,
                inf: i.inf,
                den: i.den,
                ent: i.ent,
                inc: i.inc,
                num: i.num,
                div: i.div,
                qua: i.qua
              }
            )
          }
        )
      }

      stringify(
        result,
        {
          header: true,
          bom: true,
          delimiter: ';',
          columns: [
            { key: 'region', header: `Région` },
            { key: 'name', header: 'Établissement' },
            { key: 'finess', header: `Finess` },
            { key: 'type', header: `Type d'établissement` },
            { key: 'mod', header: 'Modalité' },
            { key: 'disc', header: `Discipline` },
            { key: 'spe', header: `Spécialité` },
            { key: 'uf', header: `Uf` },
            { key: 'inf', header: `Type d'infection` },
            { key: 'den', header: `Dénominateur` },
            { key: 'ent', header: `Porte d'entrée` },
            { key: 'inc', header: `Taux d'incidence` },
            { key: 'num', header: `Nombre d'infections` },
            { key: 'div', header: `Valeur du dénominateur` },
            { key: 'qua', header: `Qualité` }
          ]
        },

        function (err, output) {
          if (err != null) {
            vm.$notify({
              type: 'danger',
              title: 'Erreur !',
              content: `Impossible d'exporter les données: ${err}.`
            })
          } else {
            setTimeout(
              function () {
                vm.csv = {
                  filename: `${vm.dataset} - EXPORT INCIDENCES PAR ÉTABLISSEMENT.csv`,
                  blob: new Blob([output], { type: 'text/plain' })
                }
              }, 10)
          }
        })
    },

    onListFiltered: function (e) {
      const { filter, lists, data } = e
      if (lists.length !== 1) {
        return
      }

      this.computedInfections = lists[0]
      assert.isFrozen(this.computedInfections)
      this.currentFilter = filter
      this.totalSheetCount = data[0].length
      if (this.incidences != null) {
        this.computeIncidences()
      }
    },

    computeIncidences: function () {
      this.referenceInfections = this.computedFinalInfections
    },

    computeEstablishmentData: function (estb, infections) {
      const s = estb.surveillance.id
      const ds = this.dsall[this.year][s]

      if (ds == null) {
        return null
      }

      const result = {
        infections: [],
        estb: estb.surveillance.establishment
      }

      const estbInfections = {
        bact: [],
        pneu: []
      }

      const lower = search.lowerBound(infections, s, 'surv')
      const upper = search.upperBound(infections, s, 'surv')
      for (let j = lower; j !== upper; ++j) {
        const inf = infections[j]
        assert.equals(inf.surv, s)

        const t = inf.itb != null ? 'pneu' : 'bact'
        result.infections.push(inf)
        estbInfections[t].push(inf)
      }

      const counts = []
      try {
        counts.push(...go.incidences.countBact(estbInfections.bact))
        counts.push(...go.incidences.countPneu(estbInfections.pneu))
      } catch (e) {
        this.$notify({
          type: 'danger',
          title: result.estb.finess,
          duration: 0,
          content: `Une erreur est survenue pendant le comptage des
 infections : ${e}.`
        })
      }

      let t = null
      try {
        t = go.incidences.compute(counts, ds)
      } catch (e) {
        this.$notify({
          type: 'danger',
          title: result.estb.finess,
          duration: 0,
          content: `Une erreur est survenue pendant le calcul des
incidences : ${e}.`
        })
      }

      result.incidences = t
      result.counts = counts
      return ice.freeze(result)
    }
  },

  watch: {
    dataset: function (d) {
      if (d != null) {
        this.fill()
      }
    },

    removeDoubles: function () {
      if (this.incidences != null) {
        this.computeIncidences()
      }
    },

    infections: function (v) {
      const vm = this
      this.$nextTick(
        () => {
          vm.computedInfections = ice.freeze(v)
        }
      )
    },

    dsall: function (v) {
      this.dsallReady = Object.keys(v).length > 0
    },

    year: function () {
      this.dataset = null
    }
  },

  asyncComputed: {
    incidences: {
      get: function () {
        if (this.dsallReady ||
            this.filteredEstablishmentList == null ||
            this.filteredEstablishmentList.length === 0 ||
            this.referenceInfections == null ||
            this.referenceInfections.length === 0) {
          return null
        }

        const result = {}
        const list = this.dsallKeys

        let iteration = 0
        const step = 1
        const vm = this
        const infections = this.referenceInfections

        return spread(
          () => {
            const min = iteration * step
            const max = min + step > list.length ? list.length : min + step
            for (let i = min; i !== max; ++i) {
              const s = list[i]
              const estb = vm.filteredEstablishmentList.find(
                ss => ss.surveillance.id === s
              )
              if (estb == null) {
                continue
              }
              result[s] = vm.computeEstablishmentData(estb, infections)
            }
            iteration += 1

            const end = max === list.length
            return {
              end: end,
              final: end ? ice.freeze(result) : result
            }
          },
          15
        )
      },
      default: null
    },

    computedIncidences: {
      get: function () {
        return computeIncidences(this.incidences, this.isNational)
      },
      default: null
    },

    computedFlatDistribution: {
      get: function () {
        if (this.computedFinalInfections == null) {
          return null
        }

        let dist = null
        const vm = this
        let step = 0
        const list = this.computedFinalInfections

        return spread(
          () => {
            try {
              if (step === 0) {
                dist = distribution('bact', list, this.year)
                step = 1
                return {
                  end: false
                }
              }

              if (step === 1) {
                dist.etbregion = {
                  type: 'rep',
                  total: 0,
                  values: {}
                }
                dist.etbtype = {
                  type: 'rep',
                  total: 0,
                  values: {}
                }
                dist.p_etbregion = {
                  type: 'rep',
                  total: 0,
                  values: {}
                }
                dist.p_etbtype = {
                  type: 'rep',
                  total: 0,
                  values: {}
                }

                let etb = null
                let type = null
                let region = null
                for (let i = 0; i !== list.length; ++i) {
                  const inf = list[i]
                  if (etb == null || etb.surveillance.id !== inf.surv) {
                    etb = this.establishmentList.find(
                      e => e.surveillance.id === inf.surv
                    )
                    if (etb == null) {
                      continue
                    }
                    const surv = etb.surveillance
                    type = results.getEstablishementType(surv.establishment.type)
                    region = regions.indexOf(surv.establishment.finess)
                    if (type == null) {
                      type = 'none'
                    }
                  }

                  const prefix = inf.itb == null ? '' : 'p_'
                  const etbtype = dist[`${prefix}etbtype`]
                  const etbregion = dist[`${prefix}etbregion`]
                  ++etbtype.total
                  if (etbtype.values[type] == null) {
                    etbtype.values[type] = 1
                  } else {
                    etbtype.values[type] += 1
                  }

                  ++etbregion.total
                  if (etbregion.values[region] == null) {
                    etbregion.values[region] = 1
                  } else {
                    etbregion.values[region] += 1
                  }
                }
                step = 2
                return {
                  end: false
                }
              }

              const final = caracteristics.flatten.infections(dist, true, true)
              final.forEach(f => { f.open = true })
              return {
                end: true,
                final: ice.freeze(final)
              }
            } catch (e) {
              vm.$notify({
                type: 'danger',
                title: 'Erreur !',
                duration: 0,
                content: `Une erreur est survenue pendant le calcul des
caractéristiques : ${e}.`
              })
            }
            return {
              end: true,
              final: null
            }
          },
          15
        )
      },
      default: null
    }
  },

  computed: {
    ...mapState({
      all: state => state.infections.all,
      datasets: state => state.dataset.names.values,
      dsall: state => state.dataset,
      dsallErrors: state => state.dataset.errors
    }),

    ...mapGetters({
      getListByName: 'surveillances/listByName',
      loginRegion: 'login/region'
    }),

    datasetList: function () {
      return this.datasets[this.year].filter(
        d => d.match(/SPIADI20[0-9]{2}($|-SURV-)/) != null
      )
    },

    filterEvents: function () {
      const result = {
        filter: this.onListFiltered
      }

      if (this.isNational) {
        result.csv = this.exportSheets
      }

      return result
    },

    filterSelectionInfo: function () {
      if (this.computedInfections == null) {
        return null
      }

      return {
        statistics: {
          count: this.computedInfections.length,
          total: this.totalSheetCount
        },
        filter: this.currentFilter
      }
    },

    isNational: function () {
      return this.$route.path.match(/^\/mission/)
    },

    region: function () {
      if (this.isNational || this.loginRegion == null) {
        return null
      }

      return regions.regions[this.loginRegion].name
    },

    subtitle: function () {
      const f = this.currentFilter
      if (f === '') {
        return ''
      }

      return `Filtre actif : ${f}`
    },

    tabSubtitle: function () {
      if (this.current.etype) {
        return {
          type: this.current.etype,
          carac: this.isNational ? 'NATIONALES' : 'RÉGIONALES',
          indic: this.isNational ? 'NATIONAUX' : 'RÉGIONAUX'
        }
      }

      return null
    },

    computedFinalInfections: function () {
      const computedInfections = this.computedInfections
      if (computedInfections == null || !this.removeDoubles) {
        return computedInfections
      }

      return ice.freeze(doubles.filter(computedInfections))
    },

    filterInputList: function () {
      if (this.infections == null) {
        return []
      }

      return [
        {
          list: this.infections,
          variables: this.filterVariables
        }
      ]
    },

    filterVariables: function () {
      const result = this.sc.filterVariables(this.year).slice()
      const vm = this
      result.push(
        {
          key: 'etbtype',
          name: `Type d'établissement`,
          field: (s) => {
            const e = vm.establishmentList.find(
              e => e.surveillance.id === s.surv
            )
            const surv = e.surveillance
            const type = results.getEstablishementType(surv.establishment.type)
            if (type == null) {
              return ['none']
            }
            return [ results.establishments[type].title ]
          }
        },
        {
          key: 'region',
          name: 'Région',
          field: (s) => {
            const finess = s.estb.c
            const region = regions.getRegion(finess)
            return [region.name]
          },
          exclusive: ['region', 'finess']
        },
        {
          key: 'finess',
          name: 'Finess',
          field: (s) => {
            return [s.estb.c]
          },
          exclusive: ['region', 'finess']
        }
      )
      return ice.freeze(result)
    },

    pdfOptions: function () {
      return {
        legend: false,
        showUfs: true,
        showMean: this.computedIncidences != null
      }
    },

    computingCaracteristics: function () {
      if (this.computedFlatDistribution == null) {
        return false
      }

      const i = this.$asyncComputed.computedFlatDistribution
      return i.updating
    },

    computingIncidences: function () {
      const i = this.$asyncComputed.incidences
      if ((this.incidences != null && this.computedIncidences == null) || i.updating) {
        return true
      }
      const ni = this.$asyncComputed.computedIncidences
      return ni.updating
    },

    dsallKeys: function () {
      return Object.keys(this.dsall[this.year])
    },

    extraction: function () {
      const i = this.infections
      if (i == null) {
        return null
      }

      const list = [
        { key: 'bact', title: 'Bactériémies' },
        { key: 'pneu', title: 'Pneumopathies' }
      ]

      let result = ''
      list.forEach(
        (l, k) => {
          const v = i[l.key]
          if (v == null || v.length === 0) {
            return
          }

          const date = moment(v[0].extr.date).format('DD/MM/YYYY HH:mm:ss')
          const sep = k === 0 ? '' : ' /'
          result = `${result}${sep} ${l.title} extraites le ${date}`
        }
      )

      return result
    },

    establishmentList: function () {
      return this.getListByName(this.year)
    },

    filteredEstablishmentList: function () {
      const variables = {
        'region': (s) => {
          const finess = s.surveillance.establishment.finess
          const region = regions.getRegion(finess)
          return [region.name]
        },
        'finess': (s) => {
          return [s.surveillance.establishment.finess]
        }
      }
      let result = this.establishmentList
      let filtered = ''
      for (let v in variables) {
        const regex =
          `\\$${v} *[~:] *("[-_@$^.$|À-ÿA-Za-zÀ-ÖØ-öø-ÿ0-9 ]*"|[-_@$^.$|A-Za-zÀ-ÖØ-öø-ÿ0-9]+)`

        const fv = this.currentFilter.match(new RegExp(regex, 'g'))
        if (fv == null) {
          continue
        }

        if (fv.length > 1) {
          this.$notify(
            {
              type: 'warning',
              title: 'Expression invalide',
              content: `La variable $${v} ne peut être présente qu'une seule
fois dans l'expression.`
            }
          )
          return []
        }

        if (filtered !== '') {
          this.$notify(
            {
              type: 'warning',
              title: 'Expression invalide',
              content: `Les variables $${v} et $${filtered} ne peuvent pas
être présente toutes les deux dans l'expression.`
            }
          )
          return []
        }
        filtered = v

        const t = {}
        t[`$${v}`] = { test: variables[v] }
        const test = filter.build(t, fv[0])
        result = result.filter(e => test(e))
      }

      return result
    },

    etypes: function () {
      const result = []
      for (let t in results.establishments) {
        const e = results.establishments[t]
        result.push(
          {
            title: e.title,
            id: `${t}`
          }
        )
      }
      return result
    },

    display: function () {
      return this.establishmentList != null &&
             this.establishmentList.length > 0 &&
             this.computedFlatDistribution != null
    },

    year: function () {
      return this.$route.params.year
    },

    invalid: function () {
      if (!this.display) {
        return []
      }

      const result = []
      for (let s in this.dsallErrors[this.year]) {
        const e = this.establishmentList.find(
          ss => ss.surveillance.id === s
        )
        result.push(
          {
            id: s,
            name: e.surveillance.establishment.name,
            finess: e.surveillance.establishment.finess,
            errors: this.dsallErrors[this.year][s]
          }
        )
      }

      if (this.computedIncidences == null) {
        return result
      }

      for (let s in this.computedIncidences.excluded) {
        const v = this.computedIncidences.excluded[s]
        const p = result.find(r => r.id === v.id)
        if (p == null) {
          result.push(
            {
              id: v.id,
              name: v.name,
              finess: v.finess,
              errors: [v.error]
            }
          )
        } else {
          p.errors.push(v.error)
        }
      }
      return result
    },

    infections: function () {
      const y = this.year
      if (this.all[y] == null ||
          this.all[y].bact == null ||
          this.all[y].pneu == null) {
        return null
      }

      const list = this.all[y].bact.slice()
      list.push(...this.all[y].pneu)

      return ice.freeze(list.sort(
        (f, s) => {
          if (f.surv === s.surv) {
            const fp = f.itb != null ? 1 : 0
            const sp = s.itb != null ? 1 : 0
            return fp - sp
          }

          if (f.surv < s.surv) {
            return -1
          }

          return 1
        }
      ))
    },

    current: function () {
      if (this.selection) {
        const s = this.selection.surveillance
        const type = results.getEstablishementType(s.establishment.type)
        const result = {
          title: `${this.dataset} - ${s.establishment.name}`,
          type: type
        }

        let data = null
        if (this.incidences == null) {
          data = this.computeEstablishmentData(
            this.selection, this.computedFinalInfections
          )
        } else {
          data = this.incidences[s.id]
        }

        if (data == null) {
          return result
        }

        result.data = ice.freeze(data.incidences)
        try {
          result.distribution = ice.freeze(distribution('bact', data.infections, this.year))
        } catch (e) {
          this.$notify({
            type: 'danger',
            title: 'Erreur !',
            duration: 0,
            content: `Une erreur est survenue pendant le calcul des
caractéristiques : ${e}.`
          })
        }
        return result
      }

      if (this.computedIncidences == null || this.etype == null) {
        return null
      }

      const e = this.etype
      let title = this.dataset
      if (this.isNational) {
        title += ` - RÉSULTATS NATIONAUX`
      } else if (this.useNational) {
        title += ` - INCIDENCE ${this.region.toUpperCase()} ET POPULATION NATIONALE`
      } else {
        title += ` - RÉSULTATS ${this.region.toUpperCase()}`
      }

      return {
        title: title,
        type: e.id,
        etype: e.title,
        data: ice.freeze(this.computedIncidences.incidences[e.id])
      }
    },

    flatResults: function () {
      if (this.current == null || this.current.data == null) {
        return null
      }

      if (this.current.distribution != null) {
        const result = results.flattenIncidences(
          !this.isNational, this.current.data, this.current.type
        )
        return result
      }

      return this.current.data
    },

    otherFlatResults: function () {
      if (this.flatResults == null ||
          this.current.distribution != null ||
          this.computedIncidences == null) {
        return null
      }

      return {
        values: this.computedIncidences.incidences,
        noQuality: false
      }
    },

    currentPopStat: function () {
      if (this.computedIncidences == null) {
        return null
      }
      return this.computedIncidences.popstat
    },

    currentGetStatistics: function () {
      if (this.computedIncidences == null) {
        return null
      }

      return this.computedIncidences.getStatistics
    },

    flattenedRegionalIndicator: function () {
      if (this.selection != null || this.currentPopStat == null) {
        return null
      }

      const r = results.flattenIndicators(this.currentPopStat, this.current.type)
      return caracteristics.flatten.flatten(r.tables, r.dist)
    },

    indicators: function () {
      if (this.selection != null || this.currentPopStat == null) {
        return null
      }
      return results.computeIndicators(this.currentPopStat, this.current.type)
    },

    flatDistribution: function () {
      if (this.current.distribution != null) {
        return caracteristics.flatten.infections(
          this.current.distribution,
          false,
          true
        )
      }
      return this.computedFlatDistribution
    }
  },

  components: {
    'loading-text': loading,
    'sui-results-dashboard': suiResultsDashboard,
    'sui-results-caracteristics': suiResultsCaracteristics,
    'sui-filter-bar': suiFilterBar,
    'sui-save-blob': saveBlob,
    'c-checkbox': checkbox
  }
}
</script>
<style scoped lang="less">
@import '~variables';

#invalid-alert {
  margin-top: 2rem;
}

.caret {
  margin-left: 0.4rem;
}

.current-filter {
  color: @dark-base;
  font-weight: bold;
}

.sticky-footer {
  margin-top: -1.0rem;
  margin-bottom: 0.5rem;
  .btn {
    margin-right: 1rem;
  }
}

.doubles-button {
  span {
    display: inline-block;
  }
}
</style>
